export default __webpack_public_path__ + "assets/images/sustainability.ed93c0ed749ab7ba86ca71d76614210e.svg";